import axios from 'axios';

const validateAgreementId = (agreementId) => (
  axios.get(
    `${process.env.REACT_APP_USER_API_ENDPOINT}/nda/${agreementId}/validate`,
  ));

export default validateAgreementId;
